import { useState } from "react";
import apiClient from "../../../shared/API/apiClient";

const validate = (form) => {
  const errors = {};
  if (!form.year_label.trim())
    errors.year_label = "Reporting Year is required";
  if (!form.start_date)
    errors.start_date = "Start Date is required";
  if (!form.end_date)
    errors.end_date = "End Date is required";
  if (form.start_date && form.end_date && new Date(form.start_date) > new Date(form.end_date))
    errors.end_date = "End Date cannot be before Start Date";
  return errors;
};

const EMPTY = { year_label: "", start_date: "", end_date: "" };

const ReportingYearModal = ({ onClose, onSave }) => {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const handleBlur = (field) => () => {
    const errs = validate(form);
    if (errs[field]) setErrors((prev) => ({ ...prev, [field]: errs[field] }));
  };

  const handleSubmit = async () => {
    const errs = validate(form);
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }

    try {
      setSaving(true);
      const res = await apiClient.post("/api/reportingyear-add", {
        year_label: form.year_label.trim(),
        start_date: form.start_date,
        end_date:   form.end_date,
      });

      if (res.data?.code === 200 || res.data?.success) {
        onSave(res.data?.message || "Reporting year added successfully");
      } else {
        throw new Error(res.data?.message || "Save failed");
      }
    } catch (err) {
      console.error("Save error:", err);
      setErrors({ year_label: err.response?.data?.message || err.message || "Something went wrong" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>

        <div className="modal-header">
          <div className="modal-title">Add Reporting Year</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">

          <div className="org-form-field">
            <label className="org-field-label">
              Reporting Year <span className="required">*</span>
            </label>
            <input
              className={`org-field-input ${errors.year_label ? "org-field-input--error" : ""}`}
              placeholder="e.g. FY2026-27"
              value={form.year_label}
              onChange={handleChange("year_label")}
              onBlur={handleBlur("year_label")}
            />
            {errors.year_label && <span className="org-field-error">{errors.year_label}</span>}
          </div>

          <div className="org-form-field" style={{ marginTop: "16px" }}>
            <label className="org-field-label">
              Start Date <span className="required">*</span>
            </label>
            <input
              type="date"
              className={`org-field-input ${errors.start_date ? "org-field-input--error" : ""}`}
              value={form.start_date}
              onChange={handleChange("start_date")}
              onBlur={handleBlur("start_date")}
            />
            {errors.start_date && <span className="org-field-error">{errors.start_date}</span>}
          </div>

          <div className="org-form-field" style={{ marginTop: "16px" }}>
            <label className="org-field-label">
              End Date <span className="required">*</span>
            </label>
            <input
              type="date"
              className={`org-field-input ${errors.end_date ? "org-field-input--error" : ""}`}
              value={form.end_date}
              onChange={handleChange("end_date")}
              onBlur={handleBlur("end_date")}
            />
            {errors.end_date && <span className="org-field-error">{errors.end_date}</span>}
          </div>

        </div>

        <div className="modal-footer">
          <button className="org-btn-cancel" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="org-btn-save" onClick={handleSubmit} disabled={saving}>
            {saving ? "Saving..." : "Add"}
          </button>
        </div>

      </div>
    </div>
  );
};

export default ReportingYearModal;
